

import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Line } from 'vue-chartjs';
import dayjs from 'dayjs';

@Component
export default class LineChart extends Mixins(Line) {
  @Prop(Array)
  private data!: Array<{
    label: string;
    value: number;
  }>;
  @Prop(Object)
  private option!: {
    yAxesTicksMin: number;
    yAxesTicksMax: number;
    yAxesTicksStepSize: number;
  };

  // グラフ用のデータ
  private chartData: Chart.ChartData = {
    labels: this.data.map(d => dayjs(d.label).format('MM/DD')),
    datasets: [
      {
        data: this.data.map(d => d.value),
        borderColor: 'rgba(76, 132, 253, 0.5)',
        backgroundColor: 'rgba(54, 162, 235, 0.1)',
        pointBackgroundColor: 'rgba(76, 132, 253, 1)',
      },
    ],
  };
  private chartOptions: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
      fullWidth: false,
      reverse: false,
      rtl: false
    },
    tooltips: {
      enabled: false
    },
    plugins: {
      datalabels: {
        // hide datalabels for all datasets
        display: false,
      },
    },
    scales: {
      // 軸設定
      xAxes: [
        // Ｘ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示設定
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0)', // 補助線の色
          },
          ticks: {
            // 目盛り
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色
          },
        },
      ],
      yAxes: [
        // Ｙ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示の有無
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0.08)', // 補助線の色
          },
          ticks: {
            // 目盛り
            min: (this.option && this.option.yAxesTicksMin) || 0, // 最小値
            max: (this.option && this.option.yAxesTicksMax) || 30, // 最大値
            stepSize: (this.option && this.option.yAxesTicksStepSize) || 5, // 軸間隔
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色
          },
        },
      ],
    },
  };

  private mounted() {
    // グラフを描画
    this.renderChart(this.chartData, this.chartOptions);
  }

  @Watch('data')
  private onChangeData() {
    if (this.chartData.datasets) {
      this.chartData.labels = this.data.map(d => dayjs(d.label).format('MM/DD'));
      this.chartData.datasets[0].data = this.data.map(d => d.value);
      // グラフを描画
      this.renderChart(this.chartData, this.chartOptions);
    }
  }
}
